import FlagIcon from '@kijiji/icons/src/icons/Flag'
import { useTranslation } from 'next-i18next'

import { TRANSLATION_KEYS } from '@/constants/localization'
import { StyledReportButton } from '@/features/listing/components/report/styled'
import { MODAL_REGISTRY } from '@/features/modal/constants/modalRegistry'
import { useModal } from '@/features/modal/hooks/useModal'

/**
 * Button to report a listing.
 */
export const ListingReportButton = () => {
  const { handleOpenModal } = useModal(MODAL_REGISTRY.LISTING_REPORT)
  const { t } = useTranslation([TRANSLATION_KEYS.VIP])

  return (
    <StyledReportButton
      forwardedAs="button"
      onClick={handleOpenModal}
      variant="secondary"
      size="small"
    >
      <FlagIcon size="xsm" aria-hidden />
      {t('listing:report.button')}
    </StyledReportButton>
  )
}
